import { useEffect, useState } from "react";
//import LayersToolbar from './LayersToolbar';
import LayersContainer from "./LayersContainer";
import LayersActions from "actions/LayersActions";
import { getCachedData } from "api/Cache";

type ILayerContentProps = {
    view: any;
    newScene: boolean;
    currentProject: any;
    move?: boolean;
    addObjects: (source?: string) => void;
    moveObjects?: () => void;
    setMove?: any;
};

export default function LayersContent(props: ILayerContentProps) {
    const { view, setMove } = props;

    useEffect(() => {
        const cachedData: any = getCachedData("entities")[view.project];
        const folders = Object.values(cachedData).filter(
            (entity: any) =>
                (entity.view_type === "folder" || entity.view_type === "collection") && entity.view_ref === view.ID
        );
        LayersActions.folders = folders;
        return () => {
            LayersActions.reset();
        };
    }, [view]);

    const [selectedLayers, setSelectedLayers] = useState<any>([]);
    const [update, setUpdate] = useState(false);

    const toggleSelectedLayers = (layer: any) => {
        if (
            (layer.parent_layer &&
                selectedLayers.find((selectedLayer: any) => selectedLayer.ID === layer.parent_layer)) ||
            (selectedLayers.find((selectedLayer: any) => selectedLayer.parent_layer) && !layer.parent_layer)
        ) {
            setSelectedLayers([layer]);
        } else if (layer && layer.ID && !selectedLayers.find((selectedLayer: any) => selectedLayer.ID === layer.ID)) {
            selectedLayers.push(layer);
            setSelectedLayers([...selectedLayers]);
        } else {
            var index = selectedLayers.findIndex((selectedLayer: any) => selectedLayer.ID === layer.ID);
            if (index > -1) {
                selectedLayers.splice(index, 1);
                setSelectedLayers([...selectedLayers]);
            }
        }
    };
    const setSelectedLayer = (layers: any) => {
        if (Object.values(layers).length === 0) {
            setMove(false);
        }
        setSelectedLayers([...layers]);
    };

    const updateParent = () => {
        setUpdate(!update);
    };

    return (
        <div
            style={{
                userSelect: "none",
                height: "100%",
                width: "100%",
                display: "block",
            }}
        >
            {/**<LayersToolbar selectedLayers={selectedLayers} updateParent={updateParent} {...props} /> */}
            <LayersContainer
                selectedLayers={selectedLayers}
                setSelectedLayers={setSelectedLayer}
                toggleSelectedLayers={toggleSelectedLayers}
                updateParent={updateParent}
                {...props}
            />
        </div>
    );
}
